import {
  GET_ALL_OPERADORES,
  GET_SPECIFIC_OPERADOR,
  GET_ALL_ROUTES,
  GET_ALL_QUEUES,
  GET_ALL_DEPARTAMENTOS,
  GET_OPERADORES_MONITOR,
  LISTAR_GRUPOS_DE_ROTAS
} from './mutation-types'

export default {
  [GET_ALL_OPERADORES]: (state, operadores) => {
    state.operadores = operadores
  },
  [GET_SPECIFIC_OPERADOR]: (state, operador) => {
    state.operador = operador
  },
  [GET_ALL_QUEUES]: (state, queues) => {
    state.queues = queues
  },
  [GET_ALL_ROUTES]: (state, routes) => {
    state.routes = routes
  },
  [GET_ALL_DEPARTAMENTOS]: (state, departamentos) => {
    state.departamentos = departamentos
  },
  [GET_OPERADORES_MONITOR]: (state, operadoresMonitor) => {
    state.operadoresMonitor = operadoresMonitor
  },
  [LISTAR_GRUPOS_DE_ROTAS]: (state, gruposDeRotas) => {
    state.gruposDeRotas = gruposDeRotas
  },
}
